module.exports = __webpack_public_path__ + "static/f615b0963388017f6fe34fbaf962d47b.png";